import type * as z from "zod";
import type { ConnectionKind } from "./connection-kind";

export function createConnectionType<
  K extends ConnectionKind,
  M extends z.ZodType<object>,
  S extends z.ZodType<object>,
>(args: CreateConnectionTypeArgs<K, M, S>) {
  return args;
}

/** A connection type, stored as `integration` rows of kind `connections`. */
// Exported for declaration emit: other packages' connection types infer it. //redontIgnore
export interface CreateConnectionTypeArgs<
  K extends ConnectionKind,
  M extends z.ZodType<object>,
  S extends z.ZodType<object>,
> {
  kind: K;
  displayName: string;
  /** Non-secret fields stored as plaintext `metadata`, besides the name. */
  metadata: M;
  /** Secret fields encrypted into `credentials`; never returned to clients. */
  secret: S;
}
